<style lang="less" scoped>
  .tab {
    display: flex;
    width: 100%;
    height: 50px;
  }
  .tab-name {
    flex: 1;
    border-bottom: 1px solid #e3e3e3;
    border-left: 1px solid #e3e3e3;
    text-align: center;
    line-height: 50px;
    background-color: #f0f0f2;
    color: #a0a0a0;

    &.active {
      border-bottom: 0;
      border-left: 0;
      background-color: #fff;
      color: #303030;
    }
  }
</style>

<template lang="pug">
  .tab
    button.tab-name(
      v-for="tab in tabs",
      :class="{ active: currentTab === tab.value }",
      @click="change(tab.value)") {{ tab.label }}
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    currentTab: {
      type: String,
      required: true,
    },
  },
  methods: {
    change(tabName) {
      this.$emit('change', tabName);
    },
  },
};
</script>
